import React,{useEffect} from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toggleSidebar,hideSidebar,showSidebar } from '../redux/actions/actions';  // Import the toggle action
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Navbar';
import { Box } from '@mui/material';
import {useMediaQuery} from '@mui/material';
import {useTheme} from '@mui/material';
import Footer from '../pages/Footer';

const DashboardLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const isVisible = useSelector(state => {
    return state.sideBar?.isVisible;
  });

  // Define routes where the sidebar should be hidden (optional)
  const pagesWithHiddenSidebar = ['/login', '/signup', '/forgot-password', '/exp-runmybot', '/integrations', 'workflow-builder', 'workflow-library','process-flow'];
  const pagesHiddenOnMobile = ['/login', '/signup', '/forgot-password', '/exp-runmybot', '/dashboard', '/user-management/partner', '/user-management/customer', '/user-management/users', '/insight/graph', '/insight/report', '/logs', '/my-templates', '/inbox', '/settings', '/event-pro/calendar', '/event-pro/schedule'];
  const isOnRestrictedPage = pagesWithHiddenSidebar.some(path =>
    location.pathname.includes(path)
  );
   
  useEffect(() => {
    if (isOnRestrictedPage) {
      dispatch(hideSidebar()); // Ensure sidebar is hidden on these pages
    } else {
      dispatch(showSidebar()); // Restore sidebar when leaving a restricted page
    }
  }, [isOnRestrictedPage, dispatch]);

  // Sidebar should follow the Redux visibility state
  const isHidden = !isVisible;
  
  useEffect(()=>{
    if(isMobile){
      if(pagesHiddenOnMobile.includes(location.pathname)){
          dispatch(hideSidebar());
      }
    }

  },[isMobile,location.pathname])
    
  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Fixed Topbar */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '73px',
          zIndex: 1100,
          backgroundColor: '#fff',
        }}
      >
        <Topbar />
      </Box>

      {/* Sidebar */}
      <Sidebar
        isHidden={isHidden}
        toggleSidebar={handleToggleSidebar}
      />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginLeft: isHidden || isMobile ? 0 : '273px',
          transition: 'margin-left 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 'calc(100vh - 73px)',
          width: isHidden || isMobile ? '100%' : 'calc(100% - 273px)',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default DashboardLayout;

// import React, { useEffect, useState } from 'react';
// import { Outlet, useLocation } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import Sidebar from '../components/Sidebar';
// import Topbar from '../components/Navbar';
// import { Box } from '@mui/material';
// // import { collapseSidebar, expandSidebar } from '../actions/sidebarActions';

// const DashboardLayout = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  
//   const dispatch = useDispatch();
//   // Toggle sidebar visibility
//   const toggleSidebar = () => {
//     setSidebarHidden(!isSidebarHidden);
//   };
//   const location = useLocation();
//   // Define routes where the sidebar should not be shown (e.g., login)
//   const noSidebarRoutes = ['/login'];
//   // Define pages where the sidebar should be hidden
//   const pagesWithHiddenSidebar = ['/login','/signup', '/integrations', '/workflow-library','/workflow-builder','/exp-runmybot','/event-pro'];
//   // Check if the current page should hide the sidebar
//   let cleanedPath = location.pathname.replace(/\/\d+$/, '');  
//   const isPageWithHiddenSidebar = pagesWithHiddenSidebar.includes(cleanedPath);

//   // State to control the sidebar visibility
//   const [isSidebarHidden, setSidebarHidden] = useState(false);
//   useEffect(() => {
//     // Update the sidebar visibility based on the current page
//     setSidebarHidden(isPageWithHiddenSidebar);
//   }, [location.pathname, isPageWithHiddenSidebar]);


//   return (
//     <Box sx={{ display: 'flex' }}>
   
//       <Sidebar isHidden={isSidebarHidden} toggleSidebar={toggleSidebar} />
//       <Topbar toggleSidebar={toggleSidebar} />
//       <Box
//         className="content"
//         sx={{
//           width: '100%',
//           marginLeft: isSidebarHidden ? '0' : '250px', // Apply dynamic margin based on sidebar visibility
//           transition: 'margin-left 0.3s ease', // Optional: Add smooth transition effect
//         }}
//       >
//         <Outlet />
//       </Box>
      
//       </Box>
    
//   );
// };

// export default DashboardLayout;
